module.exports = __webpack_public_path__ + "static/media/alumni-tr.b9330968.png";